import type { CancelTokenSource } from "axios";
import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { ID } from "@/constants";
import type { IFileCardStatus } from "@/components/molecules/fileCard/types";
import type { IFileObject } from "@/interfaces";

export interface IFileMetaData {
  status: IFileCardStatus;
  percent: number | undefined;
  source: CancelTokenSource;

  /**
   * receive from server after successfully uploaded.
   */
  UUID?: string;
  file: File | IFileObject;
}

interface IFileStorProps {
  groupFilesMetadata: Map<ID, Map<ID, IFileMetaData>>;
  filesModifySignal: number;
  groupFilesIsLoading: Map<ID, boolean>;
  isLoadingModifySignal: number;
  updateIsLoadingSignal: () => void;
  updateFilesSignal: () => void;
  progressModifySignal: number;
  updateProgressSignal: () => void;
}

export const useFileStore = create<IFileStorProps>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        groupFilesMetadata: new Map(),
        groupFilesIsLoading: new Map(),
        filesModifySignal: 0,
        progressModifySignal: 0,
        isLoadingModifySignal: 0,
        updateFilesSignal() {
          set({ filesModifySignal: Math.random() });
        },
        updateProgressSignal() {
          set({ progressModifySignal: Math.random() });
        },
        updateIsLoadingSignal() {
          set({ isLoadingModifySignal: Math.random() });
        },
      }),
      {
        enabled: !import.meta.env.PROD,
        name: "fileStore",
      },
    ),
  ),
);
const filesStorFn = {
  files: useFileStore.getState().groupFilesMetadata,
  updateFilesSignal: useFileStore.getState().updateFilesSignal,
  updateProgressSignal: useFileStore.getState().updateProgressSignal,
  updateIsLoadingSignal: useFileStore.getState().updateIsLoadingSignal,
  groupFilesIsLoading: useFileStore.getState().groupFilesIsLoading,
};

export { filesStorFn };
